// Výzva k doplnění jména a příjmení po přihlášení (rozhodnutí uživatele
// 2026-10-31): uživatel se vybírá jako odpovědná osoba za pracoviště
// a opatření, proto musí mít jméno. Dokud chybí (prázdné, nebo jen e-mail),
// ukáže se místo obsahu výzva s odkazem do portálu.
import { esc, state } from './state.js';
import { portalUrl } from './licence.js';
import { db } from './boot.js';

function needsNameGate(){
  if(!state.myId || !state.ready.profiles || !db) return false;
  var p = state.profiles.get(state.myId) || {};
  if(p.firstName && p.lastName) return false;
  var dn = (p.displayName || '').trim();
  return !dn || dn.indexOf('@')>=0;
}
function renderNameGate(){
  // Údaje o člověku se mění jen v portálu (rozhodnutí uživatele 2026-11-02); po
  // uložení je databáze pošle do Auditu a realtime výzvu sám zavře.
  var url = portalUrl() + '/ucet/';
  document.getElementById('content').innerHTML = '<div class="content-narrow">' +
    '<div class="view-head"><h2>Doplňte své jméno</h2><p>Podle jména vás ostatní vyberou jako odpovědnou osobu nebo spoluauditora.</p></div>' +
    '<div class="card"><p class="set-note" style="margin-top:0">Jméno a příjmení patří k vašemu účtu BOZP-SOFTWARE a doplníte je v portálu (Můj profil). Pak se sem vraťte.</p>' +
    '<a class="btn btn-primary btn-block" id="gatePortalBtn" href="'+esc(url)+'" target="_blank" rel="noopener">Doplnit jméno v portálu</a>' +
    '<button class="btn btn-ghost btn-block" style="margin-top:8px" onclick="location.reload()">Už je doplněné — načíst znovu</button></div></div>';
}

export { needsNameGate, renderNameGate };
